import Config from '../config/constants';
import axios, { AxiosResponse } from 'axios';

/** 배너 목록을 조회합니다. */
export const apiGetBannerList = async (
  params: { page?: number; limit?: number },
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/banner/list`;
  try {
    const response = await axios.get(url, {
      headers: { access_token: accessToken },
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching banners:', error);
    throw error;
  }
};

/** 배너 이미지를 S3에 업로드합니다. */
export const apiUploadBannerImage = async (
  file: File,
  accessToken: string,
): Promise<string> => {
  const url = `${Config.API_HOST}/api/admin/banner/upload`;
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await axios.post(url, formData, {
      headers: {
        access_token: accessToken,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading banner image:', error);
    throw error;
  }
};

/** 새 배너를 생성합니다. */
export const apiCreateBanner = async (
  body: { imageUrl: string; linkUrl?: string; title?: string; isActive?: boolean; sortOrder?: number },
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/banner`;
  try {
    const response = await axios.post(url, body, {
      headers: { access_token: accessToken },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating banner:', error);
    throw error;
  }
};

/** 배너 정보를 수정합니다. */
export const apiUpdateBanner = async (
  id: number,
  body: { imageUrl?: string; linkUrl?: string; title?: string; isActive?: boolean; sortOrder?: number },
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/banner/${id}`;
  try {
    const response = await axios.patch(url, body, {
      headers: { access_token: accessToken },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating banner:', error);
    throw error;
  }
};

/** 배너를 삭제합니다. */
export const apiDeleteBanner = async (
  id: number,
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/banner/${id}`;
  try {
    const response = await axios.delete(url, {
      headers: { access_token: accessToken },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting banner:', error);
    throw error;
  }
};
